import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { LEVEL_CHOICE_MANUALLY } from '../config/values';

class CheckListManuallyBatch extends Component {
    constructor(props) {
        super(props);

        this.onClickLevelChoice = this.onClickLevelChoice.bind(this);
    }

    /**
     * 레벨 일괄 선택 클릭
     */
    onClickLevelChoice(choice) {
        const { onSelect } = this.props;
        onSelect(choice);
    }

    render() {
        const { levelChoice } = this.props;

        return (
            <section className="check-list-manually-container">
                <div className="level-select-manually-desc-container">
                    윙크학습은 보다 체계적인 학습 진행을 위해 공부를 처음 접하는
                    아이를 위한 ‘안녕, 윙크’ 단계와 본격적인 학습 진행을 위한
                    ‘수준별 윙크’ 단계로 구분되어 있습니다.
                </div>
                <div className="check-list-batch-manually-container">
                    <div className="batch-select-box">
                        <div className="batch-select-box-text-container">
                            <p>30~38개월 추천</p>
                            <p>공부를 처음 접하는 아이를 위한</p>
                            <strong>
                                <b>[안녕, 윙크] 단계</b>
                            </strong>
                        </div>
                        <div className="batch-select-box-button-container">
                            <button
                                className={classNames(
                                    'batch-select-box-button',
                                    levelChoice === LEVEL_CHOICE_MANUALLY.hello
                                        ? ' solid'
                                        : ' outlined'
                                )}
                                onClick={() => {
                                    this.onClickLevelChoice(
                                        LEVEL_CHOICE_MANUALLY.hello
                                    );
                                }}
                            >
                                선택하기
                            </button>
                        </div>
                    </div>
                    <div className="batch-select-box">
                        <div className="batch-select-box-text-container">
                            <p>본격적인 학습이 시작되는</p>
                            <strong>
                                <b>[수준별 윙크] 단계</b>
                            </strong>
                        </div>
                        <div className="batch-select-box-button-container">
                            <button
                                className={classNames(
                                    'batch-select-box-button',
                                    levelChoice === LEVEL_CHOICE_MANUALLY.custom
                                        ? ' solid'
                                        : ' outlined'
                                )}
                                onClick={() => {
                                    this.onClickLevelChoice(
                                        LEVEL_CHOICE_MANUALLY.custom
                                    );
                                }}
                            >
                                선택하기
                            </button>
                        </div>
                    </div>
                </div>
                {levelChoice === LEVEL_CHOICE_MANUALLY.hello && (
                    <img
                        src={
                            'https://us.wink.co.kr/pc/renewalV3/common/intro_hello_level_2.png'
                        }
                        alt={'intro_hello_level'}
                    />
                )}
            </section>
        );
    }
}

CheckListManuallyBatch.propTypes = {
    onSelect: PropTypes.func.isRequired,
};

export default CheckListManuallyBatch;
